import { Redirect, Route, Switch, useRouteMatch } from 'react-router';
import LoginOtp from './loginOtp';
import LoginRequireRoute from '../../routes/LoginRequireRoute';
import UserDetails from './UserDetails';
import ChangePassword from './ChangePassword';

const UserResetRoutes = (): JSX.Element => {
  const { path } = useRouteMatch();
  const result = useRouteMatch<{ slug: string }>({
    path: `${path}/:slug/`,
  });

  return (
    <Switch>
      <Route
        exact
        path={`${path}/:referenceId`}
        render={(props: any) => (
          <Redirect to={`${path}/${result?.params?.slug}/details`} from={props.location.state} />
        )}
      />
      <Route path={`${path}/:referenceId/details`} component={UserDetails} />
      <Route path={`${path}/:referenceId/verify-otp`} component={LoginOtp} />
      <Route path={`${path}/:referenceId/change-password`} component={ChangePassword} />
      <LoginRequireRoute path="*" />
    </Switch>
  );
};

export default UserResetRoutes;
